import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseFormComponent } from '../../shared/base-form/base-form.component';

@Component({
  selector: 'app-comment-form',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./comment-form.component.scss', '../../shared/base-form/base-form.component.scss']
})
export class CommentFormComponent extends BaseFormComponent implements OnInit {

  constructor(public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entityName = 'comment';
  }

  getBody() {
    const body = super.getBody();
    if (this.params) {
      body.entity = this.params.entity;
      body.ref = this.params.ref;
    }
    return body;
  }

  save(body, apply) {
    if (body.entity && body.ref) {
      super.save(body, apply);
    } else {
      this.done.emit(body);
    }
  }
}
